<template
  ><div style="padding-top:-2px;margin-top:-2px;">
    <v-label
      ><b>{{ label }}</b></v-label
    >
    <s-select-generic
      class="text"
      itemvalue="RcfID"
      :disabled="disabled"
      :value="value"
      id="RcfID" itemtext="LotProduction"
      :return-object="returnObject"
      @input="input($event)"
      :config="config"
      :full="full"
      :text="text"
      :clearable="clearable"
      :noDefault="noDefault"
    >
    </s-select-generic>
  </div>
</template>

<script>
import _sService from "@/services/FreshProduction/PrfLayetteIncidenceService.js";
export default {
  components: {},
   name: "SSelectLotProduction",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
     estado : {
      type: Number,
      default: 0,
    },
     lay : {
      type: Number,
      default: 0,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
       noDefault: {
      type: Boolean,
      default: false,
    },    
    full: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(value) {
      this.item = value;
    },
    estado (){
        this.config.params.Status=this.estado;
    },
    lay (){
        this.config.params.LayID=this.lay;
    }
    
    
  },
  methods: {
    input(val) {
      this.$emit("input", val);
      
    },
    
  },
  data: () => ({
    item: 0,
    val: "",
    items: [],
    config: {},
  }),

  created() {
     this.config = {    
      url: _sService.GetUrllistlotproduction(),
      title: this.label,
      params: { requestID: this.$fun.getUserID(), Status: this.estado, LayID:this.lay },
    };
  },
};
</script>